import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Address } from '@quorum/models/xs-resource';

export interface SelectedAddressState extends EntityState<Address> {}

export const addressAdapter: EntityAdapter<Address> = createEntityAdapter<Address>({
  selectId: (Address: Address) => Address.id,
});
export const initialAddressState: SelectedAddressState = addressAdapter.getInitialState({});
